module.exports = __webpack_public_path__ + "img/g-min.b5a308a2.jpg";